import classNames from 'classnames';
import type { FC, ReactNode } from 'react';

export const Block: FC<
  {
    title: string;
  } & Partial<{
    desc: string;
    className: string;
    sticky: boolean;
    renderMore: () => ReactNode;
    children: ReactNode;
  }>
> = (props) => {
  const { title, desc, className, sticky, renderMore, children } = props;
  return (
    <section className={className}>
      <div
        className={classNames('flex justify-between items-center mb-3 px-5', {
          'sticky top-0 z-10': sticky,
        })}
      >
        <p className="flex-1 text-base font-medium text-main">
          {title}
          {desc && (
            <span className="ml-3 text-xs font-normal text-secondary-3">
              {desc}
            </span>
          )}
        </p>
        {typeof renderMore === 'function' && <span>{renderMore()}</span>}
      </div>
      {children}
    </section>
  );
};

export { Group } from './Group';
